import React from 'react';
import { 
    CircularProgress, 
    Fab, 
    IconButton, 
    Tooltip 
} from '@mui/material';
import { 
    GetApp as GetAppIcon,
    PictureAsPdf as PictureAsPdfIcon, 
} from '@mui/icons-material'; 
import { Page, Text, View, Document, StyleSheet, usePDF } from '@react-pdf/renderer';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_TERTIARY, COMPANY_NAME } from '../../../constants';

const formatCell = (v) => (v === null || v === undefined || v === '' ? '' : String(v));

export const PdfElement = ({data, headersColumn, HandleClickPdf, isSmall, title = 'Reporte'})=>{
    const columns = headersColumn.filter((h) => h.show);
    const generatedAt = new Date().toLocaleString('es-EC', { dateStyle: 'long', timeStyle: 'short' });

    const styles = StyleSheet.create({
        page: {
            paddingTop: 28,
            paddingBottom: 44,
            paddingHorizontal: 28,
            fontFamily: 'Helvetica',
            fontSize: 8,
            color: COLOR_TERTIARY,
        },
        banner: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            borderBottomWidth: 3,
            borderBottomColor: COLOR_PRIMARY,
            paddingBottom: 8,
            marginBottom: 12,
        },
        company: { fontSize: 9, letterSpacing: 1.5, color: COLOR_SECONDARY, fontFamily: 'Helvetica-Bold' },
        title: { fontSize: 18, fontFamily: 'Helvetica-Bold', color: COLOR_TERTIARY, marginTop: 2 },
        meta: { fontSize: 8, color: '#5f6b66', textAlign: 'right' },
        metaStrong: { fontFamily: 'Helvetica-Bold', color: COLOR_PRIMARY },
        headerRow: {
            flexDirection: 'row',
            backgroundColor: COLOR_PRIMARY,
            borderLeftWidth: 4,
            borderLeftColor: COLOR_SECONDARY,
        },
        headerCell: {
            color: '#fff',
            fontFamily: 'Helvetica-Bold',
            fontSize: 8,
            textTransform: 'uppercase',
            paddingVertical: 6,
            paddingHorizontal: 5,
        },
        row: {
            flexDirection: 'row',
            minHeight: 20,
            borderBottomWidth: 0.5,
            borderBottomColor: '#d9dedb',
            alignItems: 'center',
        },
        rowAlt: { backgroundColor: `${COLOR_SECONDARY}14` },
        cell: { paddingVertical: 4, paddingHorizontal: 5, fontSize: 8 },
        footer: {
            position: 'absolute',
            bottom: 18,
            left: 28,
            right: 28,
            flexDirection: 'row',
            justifyContent: 'space-between',
            borderTopWidth: 0.5,
            borderTopColor: COLOR_SECONDARY,
            paddingTop: 5,
            fontSize: 7,
            color: '#5f6b66',
        },
    });

    const colStyle = (w) => ({ flexGrow: w || 100, flexShrink: 1, flexBasis: 0 });

    const MyDoc = (
        <Document title={title} author={COMPANY_NAME}>
            <Page size="A4" orientation="landscape" style={styles.page} wrap>
                <View style={styles.banner} fixed>
                    <View>
                        <Text style={styles.company}>{COMPANY_NAME}</Text>
                        <Text style={styles.title}>{title}</Text>
                    </View>
                    <View>
                        <Text style={styles.meta}>Generado: {generatedAt}</Text>
                        <Text style={styles.meta}>
                            Total de registros: <Text style={styles.metaStrong}>{data.length}</Text>
                        </Text>
                    </View>
                </View>

                <View style={styles.headerRow} fixed>
                    {columns.map((col, i) => (
                        <Text
                            key={`h_${i}`}
                            style={[styles.headerCell, colStyle(col.width), { textAlign: col.align || 'left' }]}
                        >
                            {col.label}
                        </Text>
                    ))}
                </View>

                {data.map((row, i) => (
                    <View
                        key={`r_${i}`}
                        style={[styles.row, i % 2 === 1 ? styles.rowAlt : {}]}
                        wrap={false}
                    >
                        {columns.map((col, j) => (
                            <Text
                                key={`c_${i}_${j}`}
                                style={[
                                    styles.cell,
                                    colStyle(col.width),
                                    { textAlign: col.align || 'left', fontFamily: col.bolder ? 'Helvetica-Bold' : 'Helvetica' },
                                ]}
                            >
                                {formatCell(row[col.id])}
                            </Text>
                        ))}
                    </View>
                ))}

                <View style={styles.footer} fixed>
                    <Text>{COMPANY_NAME} · Documento generado automáticamente</Text>
                    <Text render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`} />
                </View>
            </Page>
        </Document>
    );

    const [ instance ] = usePDF({ document: MyDoc });

    if (instance.loading) return <CircularProgress size={isSmall ? 20 : 30}  />;

    if (instance.error){ 
        console.log(instance.error);
        return <div>Something went wrong: {instance.error}</div>;
    }

    if(isSmall){
        return (
            <Tooltip arrow title="Pdf" placement="top">
            <IconButton 
                color='primary' 
                href={instance.url} 
                onClick={HandleClickPdf} 
                size='small' 
                style={{ backgroundColor:'#ECF0F1', color:'red' }}
                target='_blank' 
                >
                <PictureAsPdfIcon />
            </IconButton>
            </Tooltip>
        );
    }else{
        return (
            <Fab 
                href={instance.url} 
                onClick={HandleClickPdf} 
                size='small' 
                color='primary' 
                target='_blank'
            >
                <GetAppIcon />
            </Fab>
        );
    }
};